import { render } from "./MainApp.vue?vue&type=template&id=b8d1f2c6"
import script from "./MainApp.vue?vue&type=script&lang=js"
export * from "./MainApp.vue?vue&type=script&lang=js"

import "./MainApp.vue?vue&type=style&index=0&id=b8d1f2c6&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__